<template>
    <div class="container"  >
          <!-- @keyup.native.enter="searchItemsPatho"  -->
        <nav class="level is-mobile mt-3">
                        <div class="level-left">
                           
                          <div class="level-item">
                                <h1 class="is-size-4">Items Management for Pathology</h1>
                        </div>


                          <div class="level-item">
                                <b-tooltip label="Search">
                                <b-button type="is-primary  is-light" outlined
                                          icon-right="magnify"  
                                          @click="searchItemsPatho(true,false)"
                                          >
                                          ดูทั้งหมด
                                </b-button>
                                </b-tooltip>
                        </div>



                        </div>
                         


                        <div class="level-right">
                            <div class="level-item">
                                <b-input v-model="searchTxt" placeholder="Search Some Text" @keyup.native.enter="searchItemsPatho(false)"></b-input>
                            </div>    
                            <div class="level-item">
                                <b-tooltip label="Search">
                                <b-button type="is-primary  is-light" outlined
                                          icon-right="magnify"  
                                          @click="searchItemsPatho(false,false)"
                                           
                                          />
                                </b-tooltip>
                            </div>

                            <div class="level-item">
                                 <b-tooltip label=" Add New Item ">
                                    <b-button type="is-primary  is-light" outlined
                                            icon-left="plus"  
                                            @click="addItemsPatho"
                                            >
                                            Add New Item
                                    </b-button>
                                 </b-tooltip>
                            </div>
                        </div>
                    </nav>
        <nav class="level is-mobile mt-3">
                        <div class="level-left">
                        </div>
                         


                        <div class="level-right">
                            <div class="level-item" >
                                <p  v-if="seeAllMode" class="has-text-weight-light"> See All Items <span> found {{pathoItemsModel.length}} records</span> </p>
                                <p  v-else class="has-text-weight-light">Search for <span class="has-text-weight-semibold">"{{searchFor}}"</span> 
                                   <span> found {{pathoItemsModel.length}} records</span>
                                </p>
                            </div>   



                        </div>
                    </nav>



        
        <b-table                        
                                        v-if="!firstTimeStart"
                                        :data="isEmpty ? [] : pathoItemsModel"
                                        bordered
                                        striped
                                        narrowed
                                        hoverable
                                        :loading="isTableLoading"
                                        focusable
                                        mobile-cards>


                                    <b-table-column   label="รหัส"  v-slot="props" >
                                        <!-- {{ props.row.id }} -->
                                         <b-tooltip   position="is-top" multilined type="is-warning " >
                                                <template v-slot:content>
                                                   แก้ไข <b>{{props.row.id}}</b> <br/> <i>  {{ props.row.descp }}</i>.
                                                </template>
                                            <b-button type="is-warning"  
                                                    @click="editItemsPatho(props.row)"
                                                    icon-left="pencil"
                                                    > 
                                                    {{ props.row.id }}
                                            </b-button>
                                         </b-tooltip>
                                    </b-table-column>

                                    <b-table-column   label="รายการ"  v-slot="props" >
                                        {{ props.row.descp }}
                                    </b-table-column>



                                    <b-table-column   label="หน่วยนับ" centered  v-slot="props" >
                                        {{ props.row.unit }}
                                    </b-table-column>


                                    <b-table-column   label="ราคาขาย(บาท)"  centered v-slot="props" >
                                        {{ formatStringToCurrency(props.row.sell_price) }}
                                    </b-table-column>





                                    



                                    <template slot="empty">
                                        <section class="section">
                                            <div class="content has-text-grey has-text-centered">
                                                <p>
                                                    <b-icon
                                                            icon="emoticon-sad"
                                                            size="is-large">
                                                    </b-icon>
                                                </p>
                                                <p>Nothing here.</p>
                                            </div>
                                        </section>
                                    </template>

                                    <template slot="footer"  >
                                        <b-button type="is-primary is-light" 
                                         icon-left="reload"
                                         expanded
                                         v-if="seeAllMode"
                                         @click="searchItemsPatho(true,true)"
                                         >Load More</b-button>
                                    </template>
                                 


                                </b-table>
     


    <AddEditItemsPatho
                        v-if="isAddEditItemsPathoShowing"
                        :isActive ="isAddEditItemsPathoShowing"
                        :dataToChild="dataToChild"
                        :modeAddEditItemsPatho = "modeAddEditItemsPatho"
                        @close="closeAddEditItemsPatho"
                        @closeWithDataChange = "closeAddEditItemsPatho_WithChange"
                    />


    </div>
</template>


<script>

import {  mapActions, mapMutations, mapState } from "vuex";
import AddEditItemsPatho from './AddEditItemsPatho.vue'
import formatStringToCurrency from '../../../mixins/methods/formatStringToCurrency' 


export default {
    name : "PathoItemsManagement",
    mixins:[formatStringToCurrency,],
    components:{
        AddEditItemsPatho,
    },
    mounted(){
        if(this.firstTimeStart){
           this.searchItemsPatho(true,false)  
        }
       
    },
    computed:{
         ...mapState({
            patho_items : state => state.patho_items.patho_items ,
            firstPathoItems: state => state.patho_items.firstPathoItems ,
            skipPathoItems: state => state.patho_items.skipPathoItems ,
            firstTimeStart: state => state.patho_items.firstTimeStart ,


            searchFor: state => state.patho_items.searchFor ,
        }),

        pathoItemsModel:{
                get: function () {
                    return this.patho_items
                },
                set: function (newValue) {
                    this.setPatho_items(newValue)
                }
        },

        firstPathoItemsModel:{
                get: function () {
                    return this.firstPathoItems
                },
                set: function (newValue) {
                    this.setFirstPathoItems(newValue)
                }
        },


        skipPathoItemsModel:{
                get: function () {
                    return this.skipPathoItems
                },
                set: function (newValue) {
                    this.setSkipPathoItems(newValue)
                }
        },
    },
    methods:{
         ...mapActions({
            fetchSearchItemsPatho : 'patho_items/fetchSearchItemsPatho',
         }),
         ...mapMutations({
             setPatho_items : 'patho_items/setPatho_items',
             setFirstPathoItems: 'patho_items/setFirstPathoItems',
             setFirstTimeStart: 'patho_items/setFirstTimeStart',
             setSkipPathoItems: 'patho_items/setSkipPathoItems',
              
         }),
         closeAddEditItemsPatho_WithChange(payload){
            //    console.log(payload)
               // mode 0 == new insert
               if(payload.mode == 0){
                            // {
                            //     "idx": 1,
                            //     "id": "000000000001",
                            //     "descp": "บริการตรวจ cyto กลุ่ม 1",
                            //     "unit": "ครั้ง III",
                            //     "sell_price": 125.0,
                            //     "unit_id": 4,
                            //     "enabled": true
                            // },
                    if(!this.seeAllMode){
                       this.searchItemsPatho(false,false)
                    }
               } // if(payload.mode == 0)




               // mode 1 == edit
               if(payload.mode == 1){
                            //  {
                            //         "idx": 1,
                            //         "id": "000000000001",
                            //         "descp": "บริการตรวจ cyto กลุ่ม 1",
                            //         "unit": "ครั้ง III",
                            //         "sell_price": 125.0,
                            //         "unit_id": 4,
                            //         "enabled": true
                            //     },
                    // find part id in array same as id is edit
                    // if  found change for user  to see
                 
                    const tmp = this.pathoItemsModel.find(dat=>dat.id == payload.data.id)
                    if(tmp){
                        if(payload.data.enabled){
                         tmp.descp = payload.data.descp
                         tmp.sell_price = payload.data.sell_price   
                        }else{
                            // if disable find index for splice
                            const idex = this.pathoItemsModel.indexOf(tmp)    
                            this.pathoItemsModel.splice(idex,1)
                        }
                        
                    }


               } // if(payload.mode == 1)







               this.isAddEditItemsPathoShowing = false

         },
         closeAddEditItemsPatho(){
               this.isAddEditItemsPathoShowing = false 
         },
         addItemsPatho(){
             this.dataToChild={
                    "idx": null,
                    "id": null,
                    "descp": "",
                    "unit": -1,
                    "sell_price": null,
                    "unit_id" : null,
                    "enabled" :  true // true == default
             }
             this.modeAddEditItemsPatho = 0 // 0 == add new
             this.isAddEditItemsPathoShowing = true

         },
         editItemsPatho(payload){
             this.dataToChild={
                    "idx": payload.idx,
                    "id": payload.id,
                    "descp": payload.descp,
                    "unit": payload.unit,
                    "sell_price": payload.sell_price,
                    "unit_id" : payload.unit_id,
                    "enabled" : payload.enabled
             } 
             this.modeAddEditItemsPatho = 1 // 1 == edit
             this.isAddEditItemsPathoShowing = true
         }, 


         searchItemsPatho(allItemsMode,loadMore){
            if(allItemsMode){
                    // all items
                    // "search_txt" = ""


                    // *********************************************
                    if(loadMore){
                           // continue
                           let tmp = this.skipPathoItemsModel 
                           tmp = tmp + this.firstPathoItemsModel
                           this.setFirstPathoItems(this.firstPathoItemsModel)
                           this.setSkipPathoItems(tmp)  
                    }else{
                            // reset first skip
                            this.setFirstPathoItems( this.firstInit )
                            this.setSkipPathoItems( this.skipInit ) 
                    }


                    // *********************************************
                    this.seeAllMode = true
                    this.isTableLoading = true
                    this.fetchSearchItemsPatho({
                            "search_txt" : "",
                            "admin" : false, 
                            "loadmore" : loadMore,
                            "seeall_mode" : allItemsMode
                        }) 
                        .then(()=>{
                            this.isTableLoading = false
                            this.setFirstTimeStart(false)
                        })   


            }else{  // not all items
                    // "search_txt" = "some text"


                    this.seeAllMode = false
                    this.setFirstPathoItems(  this.firstInit)
                    this.setSkipPathoItems(this.skipInit ) 
                    
                    
                    if(this.searchTxt.length>0){
                        this.seeAllMode = false
                        this.isTableLoading = true
                        if(loadMore){
                           // continue
                           let tmp = this.skipPathoItemsModel 
                           tmp = tmp + this.firstPathoItemsModel
                           this.setFirstPathoItems(  this.firstPathoItemsModel )
                           this.setSkipPathoItems(tmp)  
                        }else{
                           // reset first skip
                           this.setFirstPathoItems(  this.firstInit)
                           this.setSkipPathoItems(this.skipInit ) 
                        }
                        


                        this.fetchSearchItemsPatho({
                                "search_txt" : this.searchTxt,
                                "admin" : false, 
                                "loadmore" : loadMore,
                                "seeall_mode" : allItemsMode
                            }) 
                            .then(()=>{
                                this.isTableLoading = false
                                this.setFirstTimeStart(false)
                            })   



                            
                    }else{  // if(this.searchTxt.length>0){
                            this.$buefy.dialog.alert({
                                title: 'Error',
                                message: 'please enter some text!',
                                type: 'is-danger',
                                hasIcon: true,
                                icon: 'alert-circle',
                                ariaRole: 'alertdialog',
                                ariaModal: true
                            })
                    }
                     
            }
             
         }
    },
    data(){
        return {
            searchTxt : "",
            isEmpty : false,
            isTableLoading : false,

            seeAllMode : true,

            firstInit : 100,
            skipInit : 0,

            isAddEditItemsPathoShowing : false,
            dataToChild : {} ,
            modeAddEditItemsPatho : 0, // 0 == Add new ( Default ), 1 == Edit
        }
    }
}
</script>